export default [
    {
        path: 'fechamento',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-fechamento' */
            '@/views/exame-imagem/fechamento/Index'
        ),
        redirect: 'fechamento/create',
        children: [
            {
                name: 'exame-imagem-fechamento-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-fechamento' */
                    '@/views/exame-imagem/fechamento/Form.vue'),
            },
        ]
    }
]